export { default } from "../../../design-system/layout/Row";



// WEBPACK FOOTER //
// ./src/_components/Layout/Row/index.jsx